import { Box, Checkbox, Image } from "@chakra-ui/react";
import { useState } from "react";
import { ModelPreview } from "@/types/creatorcenter";

type Props = {
  image: ModelPreview;
  isCheckedAll: boolean;
  // onClose: () => void;
  handleCheckBox: (e: React.ChangeEvent<HTMLInputElement>, id: string) => void;
};

const TrainingResultModalItem = (props: Props) => {
  const { image, isCheckedAll, handleCheckBox } = props;

  const [hovered, setHovered] = useState(false);
  // const imgs = [
  //   {
  //     id: "1",
  //     imageSrc: `${modelImg}`,
  //   },
  //   {
  //     id: "2",
  //     imageSrc: `${modelImg}`,
  //   },
  // ];

  return (
    <Box
      bg={"rgba(238, 241, 247, 0.5)"}
      position="relative"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <Image
        w="100%"
        h={"161.5px"}
        objectFit="cover"
        src={image.preview}
      />
      {(hovered || isCheckedAll) && (
        <Checkbox
          position={"absolute"}
          top="5px"
          right={"5px"}
          isChecked={image.isChecked}
          onChange={(e) => handleCheckBox(e, image.preview)}
        ></Checkbox>
      )}
      {/* <Box
        bg="linear-gradient(180deg, rgba(216, 216, 216, 0.37) 0%, rgba(0, 0, 0, 0.52) 79%);"
        position={"absolute"}
        bottom="0px"
        left={"0px"}
        w="100%"
        p="5px 6px"
        color={"#fff"}
        fontSize="16px"
        textAlign={"center"}
      >
        {image.filename}
      </Box> */}
    </Box>
  );
};

export default TrainingResultModalItem;
